export default __webpack_public_path__ + "static/agb.crefotrust-e4a8bef0a9eff32af1013b6e48a23cff.pdf";